module.exports = __webpack_public_path__ + "static/media/OASIS.5956b163.png";